(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Search', Search);

    /* @ngInject */
    function Search($resource, DateUtils) {
        var resourceUrl = 'api/search/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
